(() => {
  const init = () => {
    const picker = document.getElementById('product_select');
    const output = document.getElementById('mascolori-variant-stock');
    const source = document.getElementById('mascolori-stock-data');
    if (!picker || !output || !source || picker.dataset.stockBound) return;
    picker.dataset.stockBound = 'true';
    const variants = JSON.parse(source.textContent);
    const show = option => {
      const variant = variants[option?.dataset.stockVariantId];
      const valid = variant && /^(3[6-9]|4[0-8])$/.test(variant.size.trim()) && option.dataset.showFake !== 'true';
      const message = valid ? variant.message : '';
      if (output.textContent !== message) output.textContent = message;
      output.hidden = !message;
    };
    const selected = () => show(picker.querySelector('[data-stock-variant-id].active'));
    picker.addEventListener('click', event => {
      const option = event.target.closest('[data-stock-variant-id]');
      if (option) show(option);
    });
    new MutationObserver(selected).observe(picker, {subtree:true, attributes:true, attributeFilter:['class'], childList:true});
    selected();
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, {once:true});
  else init();
  document.addEventListener('shopify:section:load', init);
})();